import React from "react";
import Chart from "react-apexcharts";
import Utils from "Utils/utils";

const BarChart = ({ data = [] }) => {
  if (!data || data.length === 0) {
    return null;
  }

  const categories = data.map(item => item.label);
  const values = data.map(item => item.value);
  const colors = data.map(item => item.color);

  const options = {
    chart: {
      type: "bar",
      height: 200,
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 4,
        barHeight: "60%",
        distributed: true
      }
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => {
        return Utils.formatNumberToStringInUSFormat(val) || 0;
      },
      style: {
        fontSize: "12px",
        colors: ["#fff"],
        fontWeight: 500
      }
    },
    xaxis: {
      labels: {
        style: {
          fontSize: "12px",
          colors: "#343a40"
        },
        formatter: (val) => {
          return Utils.formatNumberToStringInUSFormat(val) || 0;
        }
      }
    },
    yaxis: {
      categories: categories,
      labels: {
        style: {
          fontSize: "12px",
          colors: "#343a40"
        }
      }
    },
    colors: colors,
    grid: {
      borderColor: "#e5e7eb",
      strokeDashArray: 4,
      xaxis: {
        lines: {
          show: true
        }
      },
      yaxis: {
        lines: {
          show: false
        }
      }
    },
    tooltip: {
      y: {
        formatter: (val) => {
          return Utils.formatNumberToStringInUSFormat(val) || 0;
        }
      }
    },
    legend: {
      show: false
    }
  };

  const series = [
    {
      name: "Value",
      data: values
    }
  ];

  return (
    <div className="linkedInBarChart">
      <Chart options={options} series={series} type="bar" height={200} />
    </div>
  );
};

export default BarChart;

